export default __webpack_public_path__ + "static/media/silverRoot.680b5069.png";